import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListAmenities from "../Components/Amenities Resale/listAmenities";
import AddAmenities from "../Components/Amenities Resale/addAmenities";
import ViewAmenities from "../Components/Amenities Resale/viewAmenities";
import AddSubAmenities from "../Components/Amenities Resale/addSubAmenities";
import EditAmenities from "../Components/Amenities Resale/editAmenities";
import EditSubAmenities from "../Components/Amenities Resale/editSubAmenities";

const AmenitiesResaleRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');a
  return (
    <Routes>
      <Route
        path="/amenities_resale"
        element={<ListAmenities></ListAmenities>}
      ></Route>
      <Route
        path="/amenities_resale/add"
        element={canAdd ? <AddAmenities></AddAmenities> : <Navigate to="/amenities" replace />}
      ></Route>
      <Route
        path="/amenities_resale/edit/:id"
        element={<EditAmenities></EditAmenities>}
      ></Route>
      <Route
        path="/amenities_resale/view/:id"
        element={<ViewAmenities></ViewAmenities>}
      ></Route>
      <Route
        path="/amenities_resale/:id/sub/add"
        element={<AddSubAmenities></AddSubAmenities>}
      ></Route>
      <Route
        path="/amenities_resale/:id/sub/edit"
        element={<EditSubAmenities></EditSubAmenities>}
      ></Route>
    </Routes>
  );
};

export default AmenitiesResaleRoutes;
